/* Tour cursor (13 Oct 2026), shared by the Portal and Tools chapters (pc-ln-portal2.js, pc-ln-tools2.js).
   A pointer that glides to the control a tour beat is about to use and clicks it, so a self-running demo
   reads as someone using the Portal. Decorative only: aria-hidden, no pointer events, hidden whenever the
   visitor's own pointer or focus is in the frame, never created with reduced motion.
   API: var c = new PCLnCursor(frameEl); c.at(el|{x,y}); c.glide(el|{x,y}, ms); c.click(); c.show(); c.hide(); */
(function () {
  if (window.PCLnCursor) return;
  var SVG = '<svg class="ln-cursor__svg" viewBox="0 0 20 24" aria-hidden="true" focusable="false"><path d="M3.2 2.4v16.9l4.1-4 2.6 6.1 3-1.3-2.6-6h5.9L3.2 2.4Z" fill="#fff" stroke="#090c17" stroke-width="1.3" stroke-linejoin="round"/></svg>';
  function ease(k) { return k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2; }
  function Cursor(host) {
    var el = document.createElement('span');
    el.className = 'ln-cursor'; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = SVG + '<i class="ln-cursor__ring"></i>';
    /* on touch screens the pointer is a tap dot: an arrow cursor would look out of place on a phone */
    if ((window.matchMedia && matchMedia('(pointer: coarse)').matches) || window.innerWidth < 750) el.classList.add('is-touch');
    host.appendChild(el);
    this.el = el; this.host = host; this.x = null; this.y = null; this.raf = 0; this.shown = false; this.key = '';
  }
  /* host-relative point: a target element (fx, fy = fraction inside it) or {x, y} */
  Cursor.prototype.point = function (t, fx, fy) {
    if (!t) return null;
    if (t.getBoundingClientRect) {
      var h = this.host.getBoundingClientRect(), r = t.getBoundingClientRect();
      if (!r.width && !r.height) return null;
      return { x: r.left - h.left + r.width * (fx == null ? 0.5 : fx), y: r.top - h.top + r.height * (fy == null ? 0.6 : fy) };
    }
    return t;
  };
  Cursor.prototype.set = function (x, y) { this.x = x; this.y = y; this.el.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)'; if (this.shown) this.el.classList.add('is-on'); };
  Cursor.prototype.at = function (t, fx, fy) { var p = this.point(t, fx, fy); if (p) { cancelAnimationFrame(this.raf); this.raf = 0; this.set(p.x, p.y); } return p; };
  /* glide along a gentle arc, the way a hand moves a mouse; starts from the resting corner the first time */
  Cursor.prototype.glide = function (t, ms, fx, fy, done) {
    var p = this.point(t, fx, fy), self = this; if (!p) return false;
    if (this.x == null) { var hr = this.host.getBoundingClientRect(); this.set(Math.min(hr.width - 40, p.x + 160), Math.min(hr.height - 40, p.y + 120)); }
    cancelAnimationFrame(this.raf);
    var x0 = this.x, y0 = this.y, dx = p.x - x0, dy = p.y - y0, d = Math.sqrt(dx * dx + dy * dy), bend = Math.min(36, d * 0.12), t0 = 0;
    if (d < 1) { if (done) done(); return true; }
    ms = Math.max(160, ms || 600);
    function step(now) {
      if (!t0) t0 = now;
      var k = Math.min(1, (now - t0) / ms), e = ease(k), arc = Math.sin(Math.PI * e) * bend;
      self.set(x0 + dx * e - dy / d * arc, y0 + dy * e + dx / d * arc);
      if (k < 1) self.raf = requestAnimationFrame(step); else { self.raf = 0; if (done) done(); }
    }
    this.raf = requestAnimationFrame(step);
    return true;
  };
  Cursor.prototype.click = function () {
    var el = this.el; el.classList.remove('is-click'); void el.offsetWidth; el.classList.add('is-click');
    clearTimeout(this.ct); this.ct = setTimeout(function () { el.classList.remove('is-click'); }, 520);
  };
  /* (14 Oct) never visible before it has a position: an unplaced cursor sat at the frame's top-left corner on first load */
  Cursor.prototype.show = function () { if (!this.shown) { this.shown = true; if (this.x != null) this.el.classList.add('is-on'); } };
  Cursor.prototype.hide = function () { if (this.shown) { this.shown = false; this.el.classList.remove('is-on'); } };
  Cursor.prototype.stop = function () { cancelAnimationFrame(this.raf); this.raf = 0; };
  window.PCLnCursor = Cursor;
})();
